module.exports = __webpack_public_path__ + "static/media/HKN.bc31c345.png";